<template>
    <v-container no-wrap class="pa-0" style="max-width:100%;margin-left:0%;overflow-y:scroll;overflow-x:hidden">
        <v-row>
            <v-container no-wrap class="pa-0" style="max-width:98%;margin-left:1%;">
                <v-card class="dialogTall" :height="cardHeight" v-if="qadialog" :dark="proMode">
                <v-card-title>
                    {{
                        selectedLog.ext_id + 
                        " | Overall: " + (selectedLog.score.total ? percenter(selectedLog.score.total.earned,selectedLog.score.total.potential) : "N/A") + 
                        " | Coder: " + selectedLog.qa_user +
                        " | QAer: " + selectedLog.lastModifiedUser
                    }}
                    <v-spacer></v-spacer>
                    Status: {{selectedLog.status}} 
                    <v-icon class="ml-1" v-if="selectedLog.status == 'REVIEWED'">mdi-check</v-icon>
                    <v-icon class="ml-1" v-else-if="selectedLog.status == 'DISPUTED'">mdi-cancel</v-icon>
                    <v-icon class="ml-1" v-else-if="selectedLog.status == 'NOT REVIEWED'">mdi-eye-off</v-icon>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text style="padding-top:10px;overflow-x:hidden">
                    <v-row>
                        <v-col cols="12" style="text-align:center;">
                            <v-textarea
                                class="textareafix4"
                                dense
                                :label="'QA Note from ' + selectedLog.qa_notes[0].user"
                                v-model="selectedLog.qa_notes[0].note"
                                outlined
                                :readonly="readonly"
                                rows="4"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mb-4">
                        <v-col cols="12" style="text-align:center;">
                            <v-row class="flex-child pa-0 ma-0">
                                <v-col
                                    class="pa-0 ma-0"
                                    cols="3"
                                >
                                    <v-row class="pa-0 ma-0">
                                        <v-col cols="12" class="pa-0 ma-0">
                                            <v-sheet
                                                class="pa-0 ma-0 text-center"
                                                :color="proMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)'"
                                                height="200"
                                                :style="(proMode ? 'border:thin solid rgba(255, 255, 255, 0.12);' : 'border:thin solid rgba(0, 0, 0, 0.12);')"
                                            >
                                                <sheet-footer>
                                                    <pre>Overall QA Score</pre>
                                                </sheet-footer>
                                                <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:7vw; line-height:7vw; font-weight: 500; color:white">{{percenter(selectedLog.score.total.earned,selectedLog.score.total.potential)}}</pre>
                                                <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:1.6vw; line-height:0.5vh; font-weight: 500; color:white">{{selectedLog.score.total.earned}}/{{selectedLog.score.total.potential}}</pre>
                                            </v-sheet>
                                        </v-col>
                                        <!-- <v-col cols="6" class="pa-0 ma-0">
                                            <v-row class="pa-0 ma-0">
                                                <v-col cols="12" class="pa-0 ma-0">
                                                    <v-sheet
                                                    class="pa-0 ma-0 text-center"
                                                    :color="proMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)'"
                                                    height="100"
                                                    :style="(proMode ? 'border:thin solid rgba(255, 255, 255, 0.12);' : 'border:thin solid rgba(0, 0, 0, 0.12);')"
                                                    >
                                                        <sheet-footer>
                                                            <pre>Total Earned</pre>
                                                        </sheet-footer>
                                                        <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:3vw; font-weight: 500; color:white">{{selectedLog.score.total.earned}}</pre>
                                                    </v-sheet>
                                                </v-col>

                                                <v-col cols="12" class="pa-0 ma-0">
                                                    <v-sheet
                                                    class="pa-0 ma-0 text-center"
                                                    :color="proMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)'"
                                                    height="100"
                                                    :style="(proMode ? 'border:thin solid rgba(255, 255, 255, 0.12);' : 'border:thin solid rgba(0, 0, 0, 0.12);')"
                                                    >
                                                        <sheet-footer>
                                                            <pre>Total Potential</pre>
                                                        </sheet-footer>
                                                        <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:3vw; font-weight: 500; color:white">{{selectedLog.score.total.potential}}</pre>
                                                    </v-sheet>
                                                </v-col>
                                            </v-row>
                                        </v-col> -->
                                    </v-row>
                                </v-col>
                                <v-col
                                    class="d-flex pa-0 ma-0"
                                    cols="5"
                                >
                                    <v-col
                                        class="d-flex pa-0 ma-0"
                                        cols="4"
                                    >
                                        <v-row class="pa-0 ma-0">
                                            <v-col cols="12" class="pa-0 ma-0">
                                                <v-sheet
                                                    class="pa-0 ma-0 text-center"
                                                    :color="proMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)'"
                                                    height="100"
                                                    :style="(proMode ? 'border:thin solid rgba(255, 255, 255, 0.12);' : 'border:thin solid rgba(0, 0, 0, 0.12);')"
                                                >
                                                    <sheet-footer>
                                                        <pre>Pro EM Score</pre>
                                                    </sheet-footer>
                                                    <div v-if="selectedLog.score.sections.pro">
                                                        <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:3vw; line-height:3vw; font-weight: 500; color:white">{{percenter(selectedLog.score.sections.pro.em_total.earned,selectedLog.score.sections.pro.em_total.potential)}}</pre>
                                                        <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:1.3vw; line-height:0.5vh; font-weight: 500; color:white">{{selectedLog.score.sections.pro.em_total.earned}}/{{selectedLog.score.sections.pro.em_total.potential}}</pre>
                                                    </div>
                                                    <div v-else>
                                                        <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:3vw; line-height:3vw; font-weight: 500; color:white">N/A</pre>
                                                    </div>
                                                </v-sheet>
                                            </v-col>

                                            <v-col cols="12" class="pa-0 ma-0">
                                                <v-sheet
                                                    class="pa-0 ma-0 text-center"
                                                    :color="proMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)'"
                                                    height="100"
                                                    :style="(proMode ? 'border:thin solid rgba(255, 255, 255, 0.12);' : 'border:thin solid rgba(0, 0, 0, 0.12);')"
                                                >
                                                    <sheet-footer>
                                                        <pre>Tech EM Score</pre>
                                                    </sheet-footer>
                                                    <div v-if="selectedLog.score.sections.tech">
                                                        <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:3vw; line-height:3vw; font-weight: 500; color:white">{{percenter(selectedLog.score.sections.tech.em_total.earned,selectedLog.score.sections.tech.em_total.potential)}}</pre>
                                                        <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:1.3vw; line-height:0.5vh; font-weight: 500; color:white">{{selectedLog.score.sections.tech.em_total.earned}}/{{selectedLog.score.sections.tech.em_total.potential}}</pre>
                                                    </div>
                                                    <div v-else>
                                                        <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:3vw; line-height:3vw; font-weight: 500; color:white">N/A</pre>
                                                    </div>
                                                </v-sheet>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col
                                        class="d-flex pa-0 ma-0"
                                        cols="4"
                                    >
                                        <v-row class="pa-0 ma-0">
                                            <v-col cols="12" class="pa-0 ma-0">
                                                <v-sheet
                                                    class="pa-0 ma-0 text-center"
                                                    :color="proMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)'"
                                                    height="100"
                                                    :style="(proMode ? 'border:thin solid rgba(255, 255, 255, 0.12);' : 'border:thin solid rgba(0, 0, 0, 0.12);')"
                                                >
                                                    <sheet-footer>
                                                        <pre>Pro CPT Score</pre>
                                                    </sheet-footer>
                                                    <div v-if="selectedLog.score.sections.pro">
                                                        <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:3vw; line-height:3vw; font-weight: 500; color:white">{{percenter(selectedLog.score.sections.pro.cpt_total.earned,selectedLog.score.sections.pro.cpt_total.potential)}}</pre>
                                                        <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:1.3vw; line-height:0.5vh; font-weight: 500; color:white">{{selectedLog.score.sections.pro.cpt_total.earned}}/{{selectedLog.score.sections.pro.cpt_total.potential}}</pre>
                                                    </div>
                                                    <div v-else>
                                                        <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:3vw; line-height:3vw; font-weight: 500; color:white">N/A</pre>
                                                    </div>
                                                </v-sheet>
                                            </v-col>

                                            <v-col cols="12" class="pa-0 ma-0">
                                                <v-sheet
                                                    class="pa-0 ma-0 text-center"
                                                    :color="proMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)'"
                                                    height="100"
                                                    :style="(proMode ? 'border:thin solid rgba(255, 255, 255, 0.12);' : 'border:thin solid rgba(0, 0, 0, 0.12);')"
                                                >
                                                    <sheet-footer>
                                                        <pre>Tech CPT Score</pre>
                                                    </sheet-footer>
                                                    <div v-if="selectedLog.score.sections.tech">
                                                        <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:3vw; line-height:3vw; font-weight: 500; color:white">{{percenter(selectedLog.score.sections.tech.cpt_total.earned,selectedLog.score.sections.tech.cpt_total.potential)}}</pre>
                                                        <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:1.3vw; line-height:0.5vh; font-weight: 500; color:white">{{selectedLog.score.sections.tech.cpt_total.earned}}/{{selectedLog.score.sections.tech.cpt_total.potential}}</pre>
                                                    </div>
                                                    <div v-else>
                                                        <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:3vw; line-height:3vw; font-weight: 500; color:white">N/A</pre>
                                                    </div>
                                                </v-sheet>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col
                                        class="d-flex pa-0 ma-0"
                                        cols="4"
                                    >
                                        <v-row class="pa-0 ma-0">
                                            <v-col cols="12" class="pa-0 ma-0">
                                                <v-sheet
                                                    class="pa-0 ma-0 text-center"
                                                    :color="proMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)'"
                                                    height="100"
                                                    :style="(proMode ? 'border:thin solid rgba(255, 255, 255, 0.12);' : 'border:thin solid rgba(0, 0, 0, 0.12);')"
                                                >
                                                    <sheet-footer>
                                                        <pre>Pro HCPCS Score</pre>
                                                    </sheet-footer>
                                                    <div v-if="selectedLog.score.sections.pro && selectedLog.score.sections.pro.hcpcs_total">
                                                        <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:3vw; line-height:3vw; font-weight: 500; color:white">{{percenter(selectedLog.score.sections.pro.hcpcs_total.earned,selectedLog.score.sections.pro.hcpcs_total.potential)}}</pre>
                                                        <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:1.3vw; line-height:0.5vh; font-weight: 500; color:white">{{selectedLog.score.sections.pro.hcpcs_total.earned}}/{{selectedLog.score.sections.pro.hcpcs_total.potential}}</pre>
                                                    </div>
                                                    <div v-else>
                                                        <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:3vw; line-height:3vw; font-weight: 500; color:white">N/A</pre>
                                                    </div>
                                                </v-sheet>
                                            </v-col>

                                            <v-col cols="12" class="pa-0 ma-0">
                                                <v-sheet
                                                    class="pa-0 ma-0 text-center"
                                                    :color="proMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)'"
                                                    height="100"
                                                    :style="(proMode ? 'border:thin solid rgba(255, 255, 255, 0.12);' : 'border:thin solid rgba(0, 0, 0, 0.12);')"
                                                >
                                                    <sheet-footer>
                                                        <pre>Tech HCPCS Score</pre>
                                                    </sheet-footer>
                                                    <div v-if="selectedLog.score.sections.tech && selectedLog.score.sections.tech.hcpcs_total">
                                                        <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:3vw; line-height:3vw; font-weight: 500; color:white">{{percenter(selectedLog.score.sections.tech.hcpcs_total.earned,selectedLog.score.sections.tech.hcpcs_total.potential)}}</pre>
                                                        <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:1.3vw; line-height:0.5vh; font-weight: 500; color:white">{{selectedLog.score.sections.tech.hcpcs_total.earned}}/{{selectedLog.score.sections.tech.hcpcs_total.potential}}</pre>
                                                    </div>
                                                    <div v-else>
                                                        <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:3vw; line-height:3vw; font-weight: 500; color:white">N/A</pre>
                                                    </div>
                                                </v-sheet>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-col>
                                <v-col
                                    class="d-flex pa-0 ma-0"
                                    cols="4"
                                >
                                    <v-row class="pa-0 ma-0">
                                        <v-col cols="6" class="pa-0 ma-0">
                                            <v-sheet
                                                class="pa-0 ma-0 text-center"
                                                :color="proMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)'"
                                                height="200"
                                                :style="(proMode ? 'border:thin solid rgba(255, 255, 255, 0.12);' : 'border:thin solid rgba(0, 0, 0, 0.12);')"
                                            >
                                                <sheet-footer>
                                                    <pre>DX Score</pre>
                                                </sheet-footer>
                                                <div v-if="selectedLog.score.sections.dx">
                                                    <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:5vw; line-height:6vw; font-weight: 500; color:white">{{percenter(selectedLog.score.sections.dx.total.earned,selectedLog.score.sections.dx.total.potential)}}</pre>
                                                    <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:1.6vw; line-height:0.5vh; font-weight: 500; color:white">{{selectedLog.score.sections.dx.total.earned}}/{{selectedLog.score.sections.dx.total.potential}}</pre>
                                                </div>
                                                <div v-else>
                                                    <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:3vw; line-height:3vw; font-weight: 500; color:white">N/A</pre>
                                                </div>
                                            </v-sheet>
                                        </v-col>

                                        <v-col cols="6" class="pa-0 ma-0">
                                            <v-sheet
                                                class="pa-0 ma-0 text-center"
                                                :color="proMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)'"
                                                height="200"
                                                :style="(proMode ? 'border:thin solid rgba(255, 255, 255, 0.12);' : 'border:thin solid rgba(0, 0, 0, 0.12);')"
                                            >
                                                <sheet-footer>
                                                    <pre>I&I Score</pre>
                                                </sheet-footer>
                                                <div v-if="selectedLog.score.sections.ini">
                                                    <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:5vw; line-height:6vw; font-weight: 500; color:white">{{percenter(selectedLog.score.sections.ini.total.earned,selectedLog.score.sections.ini.total.potential)}}</pre>
                                                    <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:1.6vw; line-height:0.5vh; font-weight: 500; color:white">{{selectedLog.score.sections.ini.total.earned}}/{{selectedLog.score.sections.ini.total.potential}}</pre>
                                                </div>
                                                <div v-else>
                                                    <pre :class="(proMode ? 'white--text' : 'grey--text text--darken-3')" style="font-size:3vw; line-height:3vw; font-weight: 500; color:white">N/A</pre>
                                                </div>
                                            </v-sheet>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-tabs
                            :dark="proMode"
                            show-arrows
                            v-model="cttab"
                            :background-color = "(proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')"
                            grow
                            height="35"
                            :style="'border-radius: 0;border:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12);':'rgba(0, 0, 0, 0.12);')"
                        >
                            <v-tabs-slider :color="proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'"></v-tabs-slider>
                            <v-tab 
                                key="res"
                                :dark="proMode"
                                :style="'border-right:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')"
                            >
                                CODING RESULTS
                            </v-tab>
                            <v-tab 
                                key="doc"
                                :dark="proMode"
                                :style="'border-right:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')"
                            >
                                PATIENT DOCUMENT
                            </v-tab>
                            <v-tab 
                                key="updoc"
                                :dark="proMode"
                                :style="'border-right:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')"
                            >
                                QA REVIEWER UPLOADS {{(qaFiles.length>0 ? "(" + qaFiles.length + ")" : "")}}
                            </v-tab>
                        </v-tabs>
                        <v-tabs-items :style="'min-width: 100%;border:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')"  :dark="proMode" v-model="cttab">
                            <v-tab-item key="res" :dark="proMode">
                                <v-row class="px-1">
                                    <v-col cols="6" v-if="encLogDetail.demographics">
                                        <v-row>
                                            <v-col cols="12" style="text-align:center;">
                                                <h2>ORIGINALLY CODED ENCOUNTER</h2>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters class="mb-3">
                                            <v-col cols="12">
                                                <v-simple-table style="border-radius:0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                    <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="7">
                                                                Demographic Data
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th class="text-left">
                                                                MRN
                                                            </th>
                                                            <th class="text-left">
                                                                Name
                                                            </th>
                                                            <th class="text-left">
                                                                Sex
                                                            </th>
                                                            <th class="text-left">
                                                                DOB
                                                            </th>
                                                            <th class="text-left">
                                                                Payer
                                                            </th>
                                                            <th class="text-left">
                                                                Disch
                                                            </th>
                                                            <th class="text-left">
                                                                Acc Date
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>{{ encLogDetail.demographics.mrn }}</td>
                                                            <td>{{ encLogDetail.demographics.lastName }}, {{ encLogDetail.demographics.firstName }}</td>
                                                            <td>{{ encLogDetail.demographics.gender }}</td>
                                                            <td>{{ encLogDetail.demographics.dob }}</td>
                                                            <td>{{ encLogDetail.demographics.payer }}</td>
                                                            <td>{{ (encLogDetail.discharge_disposition ? encLogDetail.discharge_disposition : "" ) }}</td>
                                                            <td>{{ (encLogDetail.accident_date ? encLogDetail.accident_date : "") }}</td>
                                                        </tr>
                                                    </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters class="mb-3">
                                            <v-col cols="12">
                                                <v-tabs
                                                    v-if="facCTypes.indexOf('PRO')!=-1"
                                                    :dark="proMode"
                                                    show-arrows
                                                    v-model="logdetaildostab"
                                                    grow
                                                    :style="'border-radius: 0;border:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')"
                                                >
                                                    <v-tabs-slider :color="proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'"></v-tabs-slider>
                                                    <v-tab 
                                                        v-for="(dos, dosind) in encLogDetail.codes.pro.doss"
                                                        :key="dos.dos + '_u_' + dosind"
                                                        :style="'border:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')"
                                                    >
                                                        DOS: {{dos.dos}}
                                                    </v-tab>
                                                </v-tabs>
                                                <v-tabs-items  v-if="facCTypes.indexOf('PRO')!=-1" v-model="logdetaildostab">
                                                    <v-tab-item
                                                        v-for="(dos, dosind) in encLogDetail.codes.pro.doss"
                                                        :key="dos.dos + '_u_' + dosind"
                                                    >
                                                        <v-row no-gutters>
                                                            <v-col cols="12">
                                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                                    <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="4">
                                                                                PRO EM(s)
                                                                            </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Code
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Mod(s)
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Billing Prov
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Secondary Prov
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <template v-for="(em, emind) in dos.em">
                                                                            <tr :key="(em.id ? em.id : em.code + '_pro_u_' + dos.dos)">
                                                                                <td :style="markQADis('em','pro',dosind,emind,'code')">{{ (em.code ? em.code : "" ) }}</td>
                                                                                <td :style="markQADis('em','pro',dosind,emind,'mods')">
                                                                                    <span v-if="em.mods"><span v-for="(mod,i) in em.mods" :key="mod">{{ mod }}{{(em.mods.length != i+1 ? ", " : "")}}</span></span>
                                                                                </td>
                                                                                <td :style="markQADis('em','pro',dosind,emind,'billing_provider')">{{ (em.billing_provider ? getProviderDetail(em.billing_provider) : "") }}</td>
                                                                                <td :style="markQADis('em','pro',dosind,emind,'secondary_provider')">{{ (em.secondary_provider ? getProviderDetail(em.secondary_provider) : "") }}</td>
                                                                            </tr>
                                                                            <tr v-if="activeEnc.codes.pro.doss[dosind].em[emind].tool.mdm"  :key="(em.id ? em.id : em.code)">
                                                                                <td :style="markQADis('em','pro',dosind,emind,'history','tool')">H: {{ (em.tool.history ? em.tool.history : "" ) }}</td>
                                                                                <td :style="markQADis('em','pro',dosind,emind,'exam','tool')">E: {{ (em.tool.exam ? em.tool.exam : "" ) }}</td>
                                                                                <td :style="markQADis('em','pro',dosind,emind,'mdm','tool')">M: {{ (em.tool.mdm ? em.tool.mdm : "" ) }}</td>
                                                                                <td :style="markQADis('em','pro',dosind,emind,'time','tool')">T: {{ (em.tool.time ? em.tool.time : "" ) }}</td>
                                                                            </tr>
                                                                        </template>
                                                                    </tbody>
                                                                    </template>
                                                                </v-simple-table>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row no-gutters>
                                                            <v-col cols="12">
                                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                                    <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="6">
                                                                                PRO CPT(s)
                                                                            </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Qty
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Code
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Mod(s)
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Billing Prov
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Secondary Prov
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Date Perf
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(cpt, cptind) in dos.cpt" :key="(cpt.id ? cpt.id : cpt.code + '_pro_u_' + dos.dos)">
                                                                            <td :style="markQADis('cpt','pro',dosind,cptind,'qty')">{{ ( cpt.qty ? cpt.qty : "" ) }}</td>
                                                                            <td :style="markQADis('cpt','pro',dosind,cptind,'code')">{{ (cpt.code ? cpt.code : "") }}</td>
                                                                            <td :style="markQADis('cpt','pro',dosind,cptind,'mods')">
                                                                                <span v-if="cpt.mods"><span v-for="(mod,i) in cpt.mods" :key="mod">{{ mod }}{{(cpt.mods.length != i+1 ? ", " : "")}}</span></span></td>
                                                                            <td :style="markQADis('cpt','pro',dosind,cptind,'billing_provider')">{{ (cpt.billing_provider ? getProviderDetail(cpt.billing_provider) : "") }}</td>
                                                                            <td :style="markQADis('cpt','pro',dosind,cptind,'secondary_provider')">{{ (cpt.secondary_provider ? getProviderDetail(cpt.secondary_provider) : "") }}</td>
                                                                            <td :style="markQADis('cpt','pro',dosind,cptind,'date_performed')">{{ (cpt.date_performed ? cpt.date_performed : "") }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                    </template>
                                                                </v-simple-table>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row no-gutters class="mb-3">
                                                            <v-col cols="12">
                                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                                    <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="6">
                                                                                PRO HCPCS(s)
                                                                            </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Qty
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Code
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Mod(s)
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Billing Prov
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Secondary Prov
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(hcpcs,hcpcsind) in dos.hcpcs" :key="(hcpcs.id ? hcpcs.id : hcpcs.code + '_tech_u_' + dos.dos)">
                                                                            <td :style="markQADis('hcpcs','pro',dosind,hcpcsind,'qty')">{{ ( hcpcs.qty ? hcpcs.qty : "" ) }}</td>
                                                                            <td :style="markQADis('hcpcs','pro',dosind,hcpcsind,'code','code')">{{ (hcpcs.code.code ? hcpcs.code.code : "") }}</td>
                                                                            <td :style="markQADis('hcpcs','pro',dosind,hcpcsind,'mods')">
                                                                                <span v-if="hcpcs.mods"><span v-for="(mod,i) in hcpcs.mods" :key="mod">{{ mod }}{{(hcpcs.mods.length != i+1 ? ", " : "")}}</span></span></td>
                                                                            <td :style="markQADis('hcpcs','pro',dosind,hcpcsind,'billing_provider')">{{ (hcpcs.billing_provider ? getProviderDetail(hcpcs.billing_provider) : "") }}</td>
                                                                            <td :style="markQADis('hcpcs','pro',dosind,hcpcsind,'secondary_provider')">{{ (hcpcs.secondary_provider ? getProviderDetail(hcpcs.secondary_provider) : "") }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                    </template>
                                                                </v-simple-table>
                                                            </v-col>
                                                        </v-row>
                                                    </v-tab-item>
                                                </v-tabs-items>
                                                <v-tabs
                                                    v-if="facCTypes.indexOf('TECH')!=-1"
                                                    :dark="proMode"
                                                    show-arrows
                                                    v-model="logdetaildostab2"
                                                    grow
                                                    :style="'border-radius: 0;border:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')"
                                                >
                                                    <v-tabs-slider :color="proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'"></v-tabs-slider>
                                                    <v-tab 
                                                        v-for="(dos, dosind) in encLogDetail.codes.tech.doss"
                                                        :key="dos.dos + '_ut_' + dosind"
                                                        :style="'border:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')"
                                                    >
                                                        DOS: {{dos.dos}}
                                                    </v-tab>
                                                </v-tabs>
                                                <v-tabs-items v-if="facCTypes.indexOf('TECH')!=-1" v-model="logdetaildostab2">
                                                    <v-tab-item
                                                        v-for="(dos, dosind) in encLogDetail.codes.tech.doss"
                                                        :key="dos.dos + '_' + dosind"
                                                    >
                                                        <v-row no-gutters>
                                                            <v-col cols="12">
                                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                                    <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="4">
                                                                                TECH EM(s)
                                                                            </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Code
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Mod(s)
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Billing Prov
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Secondary Prov
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <template v-for="(emt,emtind) in dos.em">
                                                                            <tr :key="(emt.id ? emt.id : emt.code + '_tech_u_' + dos.dos)">
                                                                                <td :style="markQADis('em','tech',dosind,emtind,'code')">{{ (emt.code ? emt.code : "" ) }}</td>
                                                                                <td :style="markQADis('em','tech',dosind,emtind,'mods')">
                                                                                    <span v-if="emt.mods"><span v-for="(mod,i) in emt.mods" :key="mod">{{ mod }}{{(emt.mods.length != i+1 ? ", " : "")}}</span></span>
                                                                                </td>
                                                                                <td :style="markQADis('em','tech',dosind,emtind,'billing_provider')">{{ (emt.billing_provider ? getProviderDetail(emt.billing_provider) : "") }}</td>
                                                                                <td :style="markQADis('em','tech',dosind,emtind,'secondary_provider')">{{ (emt.secondary_provider ? getProviderDetail(emt.secondary_provider) : "") }}</td>
                                                                            </tr>
                                                                            <tr v-if="emt.tool && emt.tool.selected && emt.tool.selected[0] && emt.tool.selected[0].description && emtind == 0"  :key="(emt.id ? emt.id : emt.code)">
                                                                                <td :style="markQADis('em','tech',dosind,emtind,'tool','selected')" colspan="4">
                                                                                    <span v-if="emt.tool.selected[0]">
                                                                                        Tool Desc: <span v-for="(res,i) in emt.tool.selected" :key="res">{{ res.description }}{{(emt.tool.selected.length != i+1 ? ", " : "")}}</span>
                                                                                    </span>
                                                                                </td>
                                                                            </tr>
                                                                            <tr v-if="emt.tool && emt.tool.note && emtind == 0" :key="(emt.id ? emt.id : emt.code)">
                                                                                <td colspan="4">Tool Note: {{ (emt.tool.note ? emt.tool.note : "" ) }}</td>
                                                                            </tr>
                                                                        </template>
                                                                    </tbody>
                                                                    </template>
                                                                </v-simple-table>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row no-gutters>
                                                            <v-col cols="12">
                                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                                    <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="6">
                                                                                TECH CPT(s)
                                                                            </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Qty
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Code
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Mod(s)
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Billing Prov
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Secondary Prov
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Date Perf
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(cpt,cptind) in dos.cpt" :key="(cpt.id ? cpt.id : cpt.code + '_tech_u_' + dos.dos)">
                                                                            <td :style="markQADis('cpt','tech',dosind,cptind,'qty')">{{ ( cpt.qty ? cpt.qty : "" ) }}</td>
                                                                            <td :style="markQADis('cpt','tech',dosind,cptind,'code')">{{ (cpt.code ? cpt.code : "") }}</td>
                                                                            <td :style="markQADis('cpt','tech',dosind,cptind,'mods')">
                                                                                <span v-if="cpt.mods"><span v-for="(mod,i) in cpt.mods" :key="mod">{{ mod }}{{(cpt.mods.length != i+1 ? ", " : "")}}</span></span></td>
                                                                            <td :style="markQADis('cpt','tech',dosind,cptind,'billing_provider')">{{ (cpt.billing_provider ? getProviderDetail(cpt.billing_provider) : "") }}</td>
                                                                            <td :style="markQADis('cpt','tech',dosind,cptind,'secondary_provider')">{{ (cpt.secondary_provider ? getProviderDetail(cpt.secondary_provider) : "") }}</td>
                                                                            <td :style="markQADis('cpt','tech',dosind,cptind,'date_performed')">{{ (cpt.date_performed ? cpt.date_performed : "") }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                    </template>
                                                                </v-simple-table>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row no-gutters class="mb-3">
                                                            <v-col cols="12">
                                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                                    <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="6">
                                                                                TECH HCPCS(s)
                                                                            </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Qty
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Code
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Mod(s)
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Billing Prov
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Secondary Prov
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(hcpcst,hcpcstind) in dos.hcpcs" :key="(hcpcst.id ? hcpcst.id : hcpcst.code + '_tech_u_' + dos.dos)">
                                                                            <td :style="markQADis('hcpcs','tech',dosind,hcpcstind,'qty')">{{ ( hcpcst.qty ? hcpcst.qty : "" ) }}</td>
                                                                            <td :style="markQADis('hcpcs','tech',dosind,hcpcstind,'code','code')">{{ (hcpcst.code.code ? hcpcst.code.code : "") }}</td>
                                                                            <td :style="markQADis('hcpcs','tech',dosind,hcpcstind,'mods')">
                                                                                <span v-if="hcpcst.mods"><span v-for="(mod,i) in hcpcst.mods" :key="mod">{{ mod }}{{(hcpcst.mods.length != i+1 ? ", " : "")}}</span></span></td>
                                                                            <td :style="markQADis('hcpcs','tech',dosind,hcpcstind,'billing_provider')">{{ (hcpcst.billing_provider ? getProviderDetail(hcpcst.billing_provider) : "") }}</td>
                                                                            <td :style="markQADis('hcpcs','tech',dosind,hcpcstind,'secondary_provider')">{{ (hcpcst.secondary_provider ? getProviderDetail(hcpcst.secondary_provider) : "") }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                    </template>
                                                                </v-simple-table>
                                                            </v-col>
                                                        </v-row>
                                                    </v-tab-item>
                                                </v-tabs-items>
                                                <v-tabs
                                                    :dark="proMode"
                                                    show-arrows
                                                    v-model="logdetaildostab3"
                                                    v-if="facCodeTypes.indexOf('DX')!=-1"
                                                    grow
                                                    :style="'border-radius: 0;border:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')"
                                                >
                                                    <v-tabs-slider :color="proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'"></v-tabs-slider>
                                                    <v-tab 
                                                        v-for="(dos, dosind) in encLogDetail.codes.dx.doss"
                                                        :key="dos.dos + '_u_' + dosind"
                                                        :style="'border:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')"
                                                    >
                                                        DOS: {{dos.dos}}
                                                    </v-tab>
                                                </v-tabs>
                                                <v-tabs-items v-if="facCodeTypes.indexOf('DX')!=-1" v-model="logdetaildostab3">
                                                    <v-tab-item
                                                        v-for="(dos, dosind) in encLogDetail.codes.dx.doss"
                                                        :key="dos.dos + '_u_' + dosind"
                                                    >
                                                        <v-row no-gutters>
                                                            <v-col cols="12">
                                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                                    <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="3">
                                                                                DX(s)
                                                                            </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Code
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Related CPT
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(dx,dxind) in dos.dxs" :key="(dx.id ? dx.id : dx.code.code + '_dx_' + dos.dos)">
                                                                            <td :style="markQADis('dx',null,dosind,dxind,'code','code')">{{ (dx.code.description ? dx.code.description : "") }}</td>
                                                                            <td>{{ (typeof dx.related_cpt === 'object' && dx.related_cpt !== null ? "" : dx.related_cpt) }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                    </template>
                                                                </v-simple-table>
                                                            </v-col>
                                                        </v-row>
                                                    </v-tab-item>
                                                </v-tabs-items>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="facCodeTypes.indexOf('INI')!=-1" no-gutters class="mb-3">
                                            <v-col cols="12">
                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                    <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="6">
                                                                INI CPT(s)
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th class="text-left">
                                                                Qty
                                                            </th>
                                                            <th class="text-left">
                                                                Code
                                                            </th>
                                                            <th class="text-left">
                                                                Mod(s)
                                                            </th>
                                                            <th class="text-left">
                                                                Drug
                                                            </th>
                                                            <th class="text-left">
                                                                Start Time
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(cpti,cptiind) in encLogDetail.calcs.ini.results" :key="(cpti.id ? cpti.id : cpti.starttime + '_u_' + cpti.drug)">
                                                            <td :style="markQADis('ini',null,null,cptiind,'qty')">{{ ( cpti.qty ? cpti.qty : "" ) }}</td>
                                                            <td :style="markQADis('ini',null,null,cptiind,'code')">{{ (cpti.code ? cpti.code : "") }}</td>
                                                            <td :style="markQADis('ini',null,null,cptiind,'mods')">
                                                                <span v-if="cpti.mods"><span v-for="(mod,i) in cpti.mods" :key="mod">{{ mod }}{{(cpti.mods.length != i+1 ? ", " : "")}}</span></span></td>
                                                            <td :style="markQADis('ini',null,null,cptiind,'drug')">{{ cpti.drug }}</td>
                                                            <td :style="markQADis('ini',null,null,cptiind,'dos')">{{ cpti.dos }} - {{cpti.start}}</td>
                                                        </tr>
                                                    </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="facCTypes.indexOf('PRO')!=-1" no-gutters class="mb-0">
                                            <v-col cols="12">
                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                    <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="4">
                                                                PRO CDI(s)
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th class="text-left">
                                                                Qty
                                                            </th>
                                                            <th class="text-left">
                                                                Area
                                                            </th>
                                                            <th class="text-left">
                                                                Note
                                                            </th>
                                                            <th class="text-left">
                                                                Clinical Resource
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="cdi in encLogDetail.cdis.pro" v-if="!cdi.infid && cdi.infid != 0 && cdi.area" :key="'cprou_' + JSON.stringify(cdi)">
                                                                <td>{{ ( cdi.qty ? cdi.qty : "" ) }}</td>
                                                                <td>{{ ( cdi.area ? cdi.area : "" ) }}</td>
                                                                <td>{{ ( cdi.note ? cdi.note : "" ) }}</td>
                                                                <td>{{ ( cdi.clinical_resource ? cdi.clinical_resource : "" ) }}</td>
                                                        </tr>
                                                    </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="facCTypes.indexOf('TECH')!=-1" no-gutters class="mb-0">
                                            <v-col cols="12">
                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                    <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="4">
                                                                TECH CDI(s)
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th class="text-left">
                                                                Qty
                                                            </th>
                                                            <th class="text-left">
                                                                Area
                                                            </th>
                                                            <th class="text-left">
                                                                Note
                                                            </th>
                                                            <th class="text-left">
                                                                Clinical Resource
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="cdit in encLogDetail.cdis.tech" v-if="!cdit.infid && cdit.infid != 0 && cdit.area" :key="'ctechu_' + JSON.stringify(cdit)">
                                                                <td>{{ ( cdit.qty ? cdit.qty : "" ) }}</td>
                                                                <td>{{ ( cdit.area ? cdit.area : "" ) }}</td>
                                                                <td>{{ ( cdit.note ? cdit.note : "" ) }}</td>
                                                                <td>{{ ( cdit.clinical_resource ? cdit.clinical_resource : "" ) }}</td>
                                                        </tr>
                                                    </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="facCodeTypes.indexOf('INI')!=-1" no-gutters class="mb-2">
                                            <v-col cols="12">
                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                    <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="4">
                                                                INI CDI(s)
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th class="text-left">
                                                                Qty
                                                            </th>
                                                            <th class="text-left">
                                                                Area
                                                            </th>
                                                            <th class="text-left">
                                                                Note
                                                            </th>
                                                            <th class="text-left">
                                                                Clinical Resource
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="cdit in encLogDetail.cdis.tech" v-if="cdit.infid && cdit.area" :key="'ciniu_' + JSON.stringify(cdit)">
                                                            <td>{{ ( cdit.qty ? cdit.qty : "" ) }}</td>
                                                            <td>{{ ( cdit.area ? cdit.area : "" ) }}</td>
                                                            <td>{{ ( cdit.note ? cdit.note : "" ) }}</td>
                                                            <td>{{ ( cdit.clinical_resource ? cdit.clinical_resource.displayName : "" ) }}</td>
                                                        </tr>
                                                    </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="6" v-if="activeEnc.demographics">
                                        <v-row>
                                            <v-col cols="12" style="text-align:center;">
                                                <h2>EXPORTED ENCOUNTER</h2>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters class="mb-3">
                                            <v-col cols="12">
                                                <v-simple-table style="border-radius:0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                    <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="7">
                                                                Demographic Data
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th class="text-left">
                                                                MRN
                                                            </th>
                                                            <th class="text-left">
                                                                Name
                                                            </th>
                                                            <th class="text-left">
                                                                Sex
                                                            </th>
                                                            <th class="text-left">
                                                                DOB
                                                            </th>
                                                            <th class="text-left">
                                                                Payer
                                                            </th>
                                                            <th class="text-left">
                                                                Disch
                                                            </th>
                                                            <th class="text-left">
                                                                Acc Date
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>{{ activeEnc.demographics.mrn }}</td>
                                                            <td>{{ activeEnc.demographics.lastName }}, {{ activeEnc.demographics.firstName }}</td>
                                                            <td>{{ activeEnc.demographics.gender }}</td>
                                                            <td>{{ activeEnc.demographics.dob }}</td>
                                                            <td>{{ activeEnc.demographics.payer }}</td>
                                                            <td>{{ (activeEnc.discharge_disposition ? activeEnc.discharge_disposition : "" ) }}</td>
                                                            <td>{{ (activeEnc.accident_date ? activeEnc.accident_date : "") }}</td>
                                                        </tr>
                                                    </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters class="mb-3">
                                            <v-col cols="12">
                                                <v-tabs
                                                    v-if="facCTypes.indexOf('PRO')!=-1"
                                                    :dark="proMode"
                                                    show-arrows
                                                    v-model="logdetaildostab"
                                                    grow
                                                    :style="'border-radius: 0;border:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')"
                                                >
                                                    <v-tabs-slider :color="proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'"></v-tabs-slider>
                                                    <v-tab 
                                                        v-for="(dos, dosind) in activeEnc.codes.pro.doss"
                                                        :key="dos.dos + '_' + dosind"
                                                        :style="'border:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')"
                                                    >
                                                        DOS: {{dos.dos}}
                                                    </v-tab>
                                                </v-tabs>
                                                <v-tabs-items  v-if="facCTypes.indexOf('PRO')!=-1" v-model="logdetaildostab">
                                                    <v-tab-item
                                                        v-for="(dos, dosind) in activeEnc.codes.pro.doss"
                                                        :key="dos.dos + '_' + dosind"
                                                    >
                                                        <v-row no-gutters>
                                                            <v-col cols="12">
                                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                                    <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="4">
                                                                                PRO EM(s)
                                                                            </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Code
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Mod(s)
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Billing Prov
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Secondary Prov
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <template v-for="(em, emind) in dos.em">
                                                                            <tr :key="(em.id ? em.id : em.code + '_pro_' + dos.dos)">
                                                                                <td>{{ (em.code ? em.code : "" ) }}</td>
                                                                                <td>
                                                                                    <span v-if="em.mods"><span v-for="(mod,i) in em.mods" :key="mod">{{ mod }}{{(em.mods.length != i+1 ? ", " : "")}}</span></span>
                                                                                </td>
                                                                                <td>{{ (em.billing_provider ? getProviderDetail(em.billing_provider) : "") }}</td>
                                                                                <td>{{ (em.secondary_provider ? getProviderDetail(em.secondary_provider) : "") }}</td>
                                                                            </tr>
                                                                            <tr v-if="em.tool && em.tool.history && emind == 0"  :key="(em.id ? em.id : em.code)">
                                                                                <td>H: {{ (em.tool.history ? em.tool.history : "" ) }}</td>
                                                                                <td>E: {{ (em.tool.exam ? em.tool.exam : "" ) }}</td>
                                                                                <td>M: {{ (em.tool.mdm ? em.tool.mdm : "" ) }}</td>
                                                                                <td>T: {{ (em.tool.time ? em.tool.time : "" ) }}</td>
                                                                            </tr>
                                                                        </template>
                                                                    </tbody>
                                                                    </template>
                                                                </v-simple-table>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row no-gutters>
                                                            <v-col cols="12">
                                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                                    <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="6">
                                                                                PRO CPT(s)
                                                                            </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Qty
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Code
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Mod(s)
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Billing Prov
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Secondary Prov
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Date Perf
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="cpt in dos.cpt" :key="(cpt.id ? cpt.id : cpt.code + '_pro_' + dos.dos)">
                                                                            <td>{{ ( cpt.qty ? cpt.qty : "" ) }}</td>
                                                                            <td>{{ (cpt.code ? cpt.code : "") }}</td>
                                                                            <td>
                                                                                <span v-if="cpt.mods"><span v-for="(mod,i) in cpt.mods" :key="mod">{{ mod }}{{(cpt.mods.length != i+1 ? ", " : "")}}</span></span></td>
                                                                            <td>{{ (cpt.billing_provider ? getProviderDetail(cpt.billing_provider) : "") }}</td>
                                                                            <td>{{ (cpt.secondary_provider ? getProviderDetail(cpt.secondary_provider) : "") }}</td>
                                                                            <td>{{ (cpt.date_performed ? cpt.date_performed : "") }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                    </template>
                                                                </v-simple-table>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row no-gutters class="mb-3">
                                                            <v-col cols="12">
                                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                                    <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="6">
                                                                                PRO HCPCS(s)
                                                                            </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Qty
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Code
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Mod(s)
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Billing Prov
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Secondary Prov
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="hcpcs in dos.hcpcs" :key="(hcpcs.id ? hcpcs.id : hcpcs.code + '_pro_' + dos.dos)">
                                                                            <td>{{ ( hcpcs.qty ? hcpcs.qty : "" ) }}</td>
                                                                            <td>{{ (hcpcs.code.code ? hcpcs.code.code : "") }}</td>
                                                                            <td>
                                                                                <span v-if="hcpcs.mods"><span v-for="(mod,i) in hcpcs.mods" :key="mod">{{ mod }}{{(hcpcs.mods.length != i+1 ? ", " : "")}}</span></span></td>
                                                                            <td>{{ (hcpcs.billing_provider ? getProviderDetail(hcpcs.billing_provider) : "") }}</td>
                                                                            <td>{{ (hcpcs.secondary_provider ? getProviderDetail(hcpcs.secondary_provider) : "") }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                    </template>
                                                                </v-simple-table>
                                                            </v-col>
                                                        </v-row>
                                                    </v-tab-item>
                                                </v-tabs-items>
                                                <v-tabs
                                                    v-if="facCTypes.indexOf('TECH')!=-1"
                                                    :dark="proMode"
                                                    show-arrows
                                                    v-model="logdetaildostab2"
                                                    grow
                                                    :style="'border-radius: 0;border:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')"
                                                >
                                                    <v-tabs-slider :color="proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'"></v-tabs-slider>
                                                    <v-tab 
                                                        v-for="(dos, dosind) in activeEnc.codes.tech.doss"
                                                        :key="dos.dos + '_' + dosind"
                                                        :style="'border:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')"
                                                    >
                                                        DOS: {{dos.dos}}
                                                    </v-tab>
                                                </v-tabs>
                                                <v-tabs-items v-if="facCTypes.indexOf('TECH')!=-1" v-model="logdetaildostab2">
                                                    <v-tab-item
                                                        v-for="(dos, dosind) in activeEnc.codes.tech.doss"
                                                        :key="dos.dos + '_' + dosind"
                                                    >
                                                        <v-row no-gutters>
                                                            <v-col cols="12">
                                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                                    <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="4">
                                                                                TECH EM(s)
                                                                            </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Code
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Mod(s)
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Billing Prov
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Secondary Prov
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <template v-for="(emt,emtind) in dos.em">
                                                                            <tr :key="(emt.id ? emt.id : emt.code + '_tech_' + dos.dos)">
                                                                                <td>{{ (emt.code ? emt.code : "" ) }}</td>
                                                                                <td>
                                                                                    <span v-if="emt.mods"><span v-for="(mod,i) in emt.mods" :key="mod">{{ mod }}{{(emt.mods.length != i+1 ? ", " : "")}}</span></span>
                                                                                </td>
                                                                                <td>{{ (emt.billing_provider ? getProviderDetail(emt.billing_provider) : "") }}</td>
                                                                                <td>{{ (emt.secondary_provider ? getProviderDetail(emt.secondary_provider) : "") }}</td>
                                                                            </tr>
                                                                            <tr v-if="emt.tool && emt.tool.selected && emt.tool.selected[0] && emt.tool.selected[0].description && emtind == 0"  :key="(emt.id ? emt.id : emt.code)">
                                                                                <td colspan="4">
                                                                                    <span v-if="emt.tool.selected[0]">
                                                                                        Tool Desc: <span v-for="(res,i) in emt.tool.selected" :key="res">{{ res.description }}{{(emt.tool.selected.length != i+1 ? ", " : "")}}</span>
                                                                                    </span>
                                                                                </td>
                                                                            </tr>
                                                                            <tr v-if="emt.tool && emt.tool.note && emtind == 0" :key="(emt.id ? emt.id : emt.code)">
                                                                                <td colspan="4">Tool Note: {{ (emt.tool.note ? emt.tool.note : "" ) }}</td>
                                                                            </tr>
                                                                        </template>
                                                                    </tbody>
                                                                    </template>
                                                                </v-simple-table>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row no-gutters>
                                                            <v-col cols="12">
                                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                                    <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="6">
                                                                                TECH CPT(s)
                                                                            </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Qty
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Code
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Mod(s)
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Billing Prov
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Secondary Prov
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Date Perf
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="cpt in dos.cpt" :key="(cpt.id ? cpt.id : cpt.code + '_tech_' + dos.dos)">
                                                                            <td>{{ ( cpt.qty ? cpt.qty : "" ) }}</td>
                                                                            <td>{{ (cpt.code ? cpt.code : "") }}</td>
                                                                            <td>
                                                                                <span v-if="cpt.mods"><span v-for="(mod,i) in cpt.mods" :key="mod">{{ mod }}{{(cpt.mods.length != i+1 ? ", " : "")}}</span></span></td>
                                                                            <td>{{ (cpt.billing_provider ? getProviderDetail(cpt.billing_provider) : "") }}</td>
                                                                            <td>{{ (cpt.secondary_provider ? getProviderDetail(cpt.secondary_provider) : "") }}</td>
                                                                            <td>{{ (cpt.date_performed ? cpt.date_performed : "") }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                    </template>
                                                                </v-simple-table>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row no-gutters class="mb-3">
                                                            <v-col cols="12">
                                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                                    <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="6">
                                                                                TECH HCPCS(s)
                                                                            </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Qty
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Code
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Mod(s)
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Billing Prov
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Secondary Prov
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Date Perf
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="hcpcst in dos.hcpcs" :key="(hcpcst.id ? hcpcst.id : hcpcst.code + '_tech_' + dos.dos)">
                                                                            <td>{{ ( hcpcst.qty ? hcpcst.qty : "" ) }}</td>
                                                                            <td>{{ (hcpcst.code.code ? hcpcst.code.code : "") }}</td>
                                                                            <td>
                                                                                <span v-if="hcpcst.mods"><span v-for="(mod,i) in hcpcst.mods" :key="mod">{{ mod }}{{(hcpcst.mods.length != i+1 ? ", " : "")}}</span></span></td>
                                                                            <td>{{ (hcpcst.billing_provider ? getProviderDetail(hcpcst.billing_provider) : "") }}</td>
                                                                            <td>{{ (hcpcst.secondary_provider ? getProviderDetail(hcpcst.secondary_provider) : "") }}</td>
                                                                            <td>{{ (hcpcst.date_performed ? hcpcst.date_performed : "") }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                    </template>
                                                                </v-simple-table>
                                                            </v-col>
                                                        </v-row>
                                                    </v-tab-item>
                                                </v-tabs-items>
                                                <v-tabs
                                                    :dark="proMode"
                                                    show-arrows
                                                    v-model="logdetaildostab3"
                                                    v-if="facCodeTypes.indexOf('DX')!=-1"
                                                    grow
                                                    :style="'border-radius: 0;border:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')"
                                                >
                                                    <v-tabs-slider :color="proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'"></v-tabs-slider>
                                                    <v-tab 
                                                        v-for="(dos, dosind) in activeEnc.codes.dx.doss"
                                                        :key="dos.dos + '_' + dosind"
                                                        :style="'border:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')"
                                                    >
                                                        DOS: {{dos.dos}}
                                                    </v-tab>
                                                </v-tabs>
                                                <v-tabs-items v-if="facCodeTypes.indexOf('DX')!=-1" v-model="logdetaildostab3">
                                                    <v-tab-item
                                                        v-for="(dos, dosind) in activeEnc.codes.dx.doss"
                                                        :key="dos.dos + '_' + dosind"
                                                    >
                                                        <v-row no-gutters>
                                                            <v-col cols="12">
                                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                                    <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="3">
                                                                                DX(s)
                                                                            </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Code
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Related CPT
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="dx in dos.dxs" :key="(dx.id ? dx.id : dx.code.code + '_dx_' + dos.dos)">
                                                                            <td>{{ (dx.code.description ? dx.code.description : "") }}</td>
                                                                            <td>{{ (typeof dx.related_cpt === 'object' && dx.related_cpt !== null ? "" : dx.related_cpt) }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                    </template>
                                                                </v-simple-table>
                                                            </v-col>
                                                        </v-row>
                                                    </v-tab-item>
                                                </v-tabs-items>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="facCodeTypes.indexOf('INI')!=-1" no-gutters class="mb-3">
                                            <v-col cols="12">
                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                    <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="6">
                                                                INI CPT(s)
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th class="text-left">
                                                                Qty
                                                            </th>
                                                            <th class="text-left">
                                                                Code
                                                            </th>
                                                            <th class="text-left">
                                                                Mod(s)
                                                            </th>
                                                            <th class="text-left">
                                                                Drug
                                                            </th>
                                                            <th class="text-left">
                                                                Start Time
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="cpti in activeEnc.calcs.ini.results" :key="(cpti.id ? cpti.id : cpti.starttime + '_' + cpti.drug)">
                                                            <td>{{ ( cpti.qty ? cpti.qty : "" ) }}</td>
                                                            <td>{{ (cpti.code ? cpti.code : "") }}</td>
                                                            <td>
                                                                <span v-if="cpti.mods"><span v-for="(mod,i) in cpti.mods" :key="mod">{{ mod }}{{(cpti.mods.length != i+1 ? ", " : "")}}</span></span></td>
                                                            <td>{{ cpti.drug }}</td>
                                                            <td>{{ cpti.dos }} - {{cpti.start}}</td>
                                                        </tr>
                                                    </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="facCTypes.indexOf('PRO')!=-1" no-gutters class="mb-0">
                                            <v-col cols="12">
                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                    <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="4">
                                                                PRO CDI(s)
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th class="text-left">
                                                                Qty
                                                            </th>
                                                            <th class="text-left">
                                                                Area
                                                            </th>
                                                            <th class="text-left">
                                                                Note
                                                            </th>
                                                            <th class="text-left">
                                                                Clinical Resource
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="cdi in activeEnc.cdis.pro" v-if="!cdi.infid && cdi.infid != 0 && cdi.area" :key="'cpro' + JSON.stringify(cdi)">
                                                                <td>{{ ( cdi.qty ? cdi.qty : "" ) }}</td>
                                                                <td>{{ ( cdi.area ? cdi.area : "" ) }}</td>
                                                                <td>{{ ( cdi.note ? cdi.note : "" ) }}</td>
                                                                <td>{{ ( cdi.clinical_resource ? cdi.clinical_resource : "" ) }}</td>
                                                        </tr>
                                                    </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="facCTypes.indexOf('TECH')!=-1" no-gutters class="mb-0">
                                            <v-col cols="12">
                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                    <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="4">
                                                                TECH CDI(s)
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th class="text-left">
                                                                Qty
                                                            </th>
                                                            <th class="text-left">
                                                                Area
                                                            </th>
                                                            <th class="text-left">
                                                                Note
                                                            </th>
                                                            <th class="text-left">
                                                                Clinical Resource
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="cdit in activeEnc.cdis.tech" v-if="!cdit.infid && cdit.infid != 0 && cdit.area" :key="'ctech' + JSON.stringify(cdit)">
                                                                <td>{{ ( cdit.qty ? cdit.qty : "" ) }}</td>
                                                                <td>{{ ( cdit.area ? cdit.area : "" ) }}</td>
                                                                <td>{{ ( cdit.note ? cdit.note : "" ) }}</td>
                                                                <td>{{ ( cdit.clinical_resource ? cdit.clinical_resource : "" ) }}</td>
                                                        </tr>
                                                    </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="facCodeTypes.indexOf('INI')!=-1" no-gutters class="mb-2">
                                            <v-col cols="12">
                                                <v-simple-table style="border-radius: 0;" :dark="proMode" dense :class="proMode ? 'encLogTable' : 'encLogTableLt'">
                                                    <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left text-h6" :style="'border-bottom:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')" colspan="4">
                                                                INI CDI(s)
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th class="text-left">
                                                                Qty
                                                            </th>
                                                            <th class="text-left">
                                                                Area
                                                            </th>
                                                            <th class="text-left">
                                                                Note
                                                            </th>
                                                            <th class="text-left">
                                                                Clinical Resource
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="cdit in activeEnc.cdis.tech" v-if="cdit.infid && cdit.area" :key="'cini' + JSON.stringify(cdit)">
                                                            <td>{{ ( cdit.qty ? cdit.qty : "" ) }}</td>
                                                            <td>{{ ( cdit.area ? cdit.area : "" ) }}</td>
                                                            <td>{{ ( cdit.note ? cdit.note : "" ) }}</td>
                                                            <td>{{ ( cdit.clinical_resource ? cdit.clinical_resource.displayName : "" ) }}</td>
                                                        </tr>
                                                    </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <v-tab-item key="doc" :dark="proMode">
                                <v-row no-gutters>
                                    <v-col style="max-width:100%">
                                        <v-card elevation="0" v-if="activeDocs[0]">
                                            <!-- <PDFJSViewer :docURL="encPDF" /> -->
                                            <EnhancedDocViewer :proMode="proMode" :facility="activeEnc.facility" :client="activeEnc.client" :docs="activeDocs" :key="activeDocs[0].dockey" height="625px" />
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <v-tab-item key="updoc" :dark="proMode">
                                <v-row no-gutters>
                                    <v-col style="max-width:100%">
                                        <v-card elevation="0" v-if="displayQADocs">
                                            <QADocViewer :proMode="proMode" :facility="activeEnc.facility" :client="activeEnc.client" :docs="qaFiles" :activeEncId="activeEnc.encid" height="625px" />
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <!-- <v-col cols="3">
                        <v-btn
                            color="primary"
                            :text="proMode"
                            :outlined="proMode"
                            block
                            style="border-radius:0"
                            @click="closeLogDetail"
                        >
                            CLOSE DETAIL
                        </v-btn>
                    </v-col>
                    <v-spacer></v-spacer> -->
                    <v-col cols="5">
                        <v-btn
                            color="error"
                            :text="proMode"
                            :outlined="proMode"
                            block
                            style="border-radius:0"
                            @click="openDispute(selectedLog)"
                            :disabled="disableReviewed"
                        >
                            {{(selectedLog.dispute ? "SHOW DISPUTE" : "DISPUTE QA")}}
                        </v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="5">
                        <v-btn
                            color="success"
                            :text="proMode"
                            :outlined="proMode"
                            block
                            style="border-radius:0"
                            @click="saveQA(selectedLog,'REVIEWED')"
                            :disabled="disableReviewed"
                        >
                            MARK REVIEWED
                        </v-btn>
                    </v-col>
                </v-card-actions>
            </v-card>
            </v-container>
        </v-row>
        <v-dialog
            v-if="notesdialog"
            v-model="notesdialog"
            scrollable
            max-width="800px"
            @click:outside="closeNotes"
        >
            <!-- <template v-slot:activator="{ on, attrs }">
                <v-btn
                :color="proMode ? 'white' : 'black'"
                small
                text
                v-bind="attrs"
                v-on="on"
                :disabled="!activeEnc.encid"
                class="px-0"
                >
                    <v-icon>mdi-note-text</v-icon> {{(activeEnc.notes.length > 0 ? "(" + activeEnc.notes.length + ")" : "")}}
                </v-btn>
            </template> -->
            <v-card  :dark="proMode">
                <v-card-title>
                    Notes for 
                    {{
                        activeEnc.ext_id + " | " + 
                        activeEnc.demographics.lastName + ", " + activeEnc.demographics.firstName + " - " +
                        activeEnc.dos
                    }}
                    <v-spacer></v-spacer>
                    <v-icon >mdi-note-text</v-icon> ({{(activeEnc.notes ? activeEnc.notes.length : 0)}})
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 400px; padding-top:10px;">
                    <v-row style="height:90px;margin-top:10px;" v-for="(note,noteind) in activeEnc.notes" :key="activeEnc.encid + '_note_' + noteind + '_' + wsUps">
                        <v-col class="pa-0" cols="12">
                            <v-textarea
                                class="demofields textareafix"
                                dense
                                :label="note.note_type + ': ' + note.user + ' - ' + new Date(note.time).toLocaleString()"
                                v-model="note.note"
                                outlined
                                readonly
                                rows="4"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row class="mt-1 mb-2">
                        <v-divider></v-divider>
                    </v-row>
                    <v-row class="">
                        <v-col style="padding:0" cols="12">
                            <v-row no-gutters style="height:40px;margin-top:5px;">
                                <v-col cols="12">
                                    <v-select
                                        class="demofields"
                                        dense
                                        label="Note Type"
                                        v-model="newnote.note_type"
                                        outlined
                                        :items=$store.getters.noteTypes
                                    ></v-select>
                                </v-col>
                                <!-- <v-col cols="6">
                                    <v-autocomplete
                                        class="demofields"
                                        dense
                                        label="Notify User"
                                        v-model="newnote.user"
                                        outlined
                                        item-text="user_name"
                                        item-value="userid"
                                        :items=$store.getters.Users
                                    ></v-autocomplete>
                                </v-col> -->
                            </v-row>
                            <v-row no-gutters style="height:60px;margin-top:5px;">
                                <v-col cols="12">
                                    <v-textarea
                                        class="demofields textareafix"
                                        dense
                                        label="Note"
                                        v-model="newnote.note"
                                        rows="4"
                                        outlined
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="mt-9">
                                <v-col cols="12">
                                    <v-btn
                                        color="success"
                                        :text="proMode"
                                        :outlined="proMode"
                                        block
                                        style="border-radius:0"
                                        @click="saveNote"
                                        :disabled="activeEncStatus != 'EXPORT' && newnote.note.length < 1"
                                    >
                                        ADD NOTE +
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <!-- <v-spacer></v-spacer>
                    <v-col cols="4">
                        <v-btn
                            color="primary"
                            text
                            outlined
                            :disabled="activeEnc.deficients && activeEnc.deficients.length==0"
                            block
                            style="border-radius:0"
                            @click="save('WAITING')"
                        >
                            UPDATE WAITING
                        </v-btn>
                    </v-col> 
                    <v-spacer></v-spacer> -->
                    <v-col cols="12">
                        <v-btn
                            color="primary"
                            :text="proMode"
                            :outlined="proMode"
                            block
                            style="border-radius:0"
                            @click="closeNotes"
                        >
                            CLOSE NOTES
                        </v-btn>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="disputedialog"
            v-model="disputedialog"
            scrollable
            max-width="800px"
            @click:outside="disputedialog=false"
        >
            <v-card  :dark="proMode">
                <v-card-title>
                    Dispute for 
                    {{
                        selectedLog.ext_id + " | " +
                        selectedLog.dos
                    }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 300px; padding-top:10px;">
                    <v-row v-if="selectedLog.dispute">
                        <v-col cols="12" class="pa-0">
                            <v-row no-gutters>
                                <v-col class="pa-0 text-subtitle-1" style="color:white" cols="12">
                                    {{selectedLog.dispute.user + ' - ' + new Date(selectedLog.dispute.time).toLocaleString()}}
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col class="pa-0" cols="12">
                                    <v-text-field
                                        class="demofields"
                                        dense
                                        label="Reason"
                                        v-model="selectedLog.dispute.reason"
                                        outlined
                                        readonly
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row no-gutters style="margin-top:-10px">
                                <v-col class="pa-0" cols="12">
                                    <v-textarea
                                        class="demofields textareafix textareafix2"
                                        dense
                                        label="Note"
                                        v-model="selectedLog.dispute.note"
                                        outlined
                                        readonly
                                        rows="2"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row v-if="selectedLog.status != 'REVIEWED'" class="mt-2 mb-2" >
                        <v-divider></v-divider>
                    </v-row>
                    <v-row v-if="selectedLog.status != 'REVIEWED'" class="" >
                        <v-col style="padding:0" cols="12">
                            <v-row no-gutters style="height:40px;margin-top:5px;">
                                <v-col cols="12">
                                    <v-select
                                        class="demofields"
                                        dense
                                        label="Dispute Reason"
                                        v-model="newDis.reason"
                                        outlined
                                        :items="disputeReasons"
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row no-gutters style="height:40px;margin-top:5px;">
                                <v-col cols="12">
                                    <v-textarea
                                        class="demofields"
                                        dense
                                        label="Note"
                                        v-model="newDis.note"
                                        outlined
                                        rows="2"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-col cols="4">
                        <v-btn
                            color="warning"
                            :text="proMode"
                            :outlined="proMode"
                            block
                            style="border-radius:0"
                            @click="disputedialog = false"
                        >
                            CANCEL
                        </v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="4">
                        <v-btn
                            color="error"
                            :text="proMode"
                            :outlined="proMode"
                            block
                            style="border-radius:0"
                            @click="saveQA(selectedLog,'DISPUTED')"
                            :disabled="selectedLog.status == 'REVIEWED'"
                        >
                            MARK DISPUTED
                        </v-btn>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import { mapGetters } from "vuex";
import EnhancedDocViewer from "../components/EnhancedDocViewer.vue";
import QADocViewer from "../components/QADocViewer.vue";
import broadcast from "../mixins/windowSync.js";
//import PDFJSViewer from '../components/PDFJSViewer.vue'
import { ulid } from 'ulid';

export default{
  name: 'QAReviewer',
    mixins: [broadcast],
    components: { 
        ulid, 
        EnhancedDocViewer, 
        QADocViewer,
        broadcast,
        SheetFooter: {
            functional: true,
            render (h, { children }) {
                return h('v-sheet', {
                    staticClass: 'mt-auto align-center justify-center d-flex px-2',
                    props: {
                        color: 'rgba(0, 0, 0, .36)',
                        dark: true,
                        height: 25,
                        style: 'width:100%;'
                    },
                }, children)
            },
        },
    },
    data: function () {
      return {
        rowHeight:0,
        cardHeight:0,
        svTableCardHeight:"",
        search:'',
        loadingEnc:false,
        loadingQAEnc:false,
        qaScore:{},
        qaEncs:[],
        activeEnc:{},
        activeDocs:[],
        qaFiles:[],
        qaScoreDetail:{},
        encLogs:[],
        encLogSearch:"",
        logHeaders:[
            { text: 'Log Time', value: 'change_time' },
            { text: 'User', value: 'user' },
            { text: 'Status', value: 'status' },
            { text: 'View Detail', value: 'view', align: 'center' }
        ],
        saving:false,
        //date: new Date().toISOString().substr(0, 10),
        menuacc: false,
        menu: false,
        modal: false,
        menu2: [],
        menu3:[],
        disputedialog: false,
        deficientdialog: false,
        notesdialog: false,
        noteListDialog: false,
        qadialog: false,
        facCTypes:[],
        facCodeTypes:[],
        selectedLog:{},
        encLogDetail:{},
        activeQaEnc:{},
        logdetaildostab:"",
        logdetaildostab2:"",
        logdetaildostab3:"",
        cttab:"",
        prodoss:[0],
        techdoss:[0],
        dxdoss:[0],
        pttab:{},
        codetabpro:{},
        codetabtech:{},
        cdipttab:"",
        dosProExpand:false,
        dosTechExpand:false,
        dosDxExpand:false,
        newnote:{
            note_type:"Internal",
            note:""
        },
        qanotein:{},
        newDis:{},
        defAdded:false,

        loadedPDF:"",
        pdfOpen:true,
        splitView:false,
        bigCodeView:false,
        svTableHeight:"",

        readonly: true,
       
        broadcastDocsOpen: false,

        descriptionLimit: 50,
        entries: [],
        isLoading: false,
        model: null,
        searchAPI:null,

        selectedSort:[],
        currentSort:"",

        disputeReasons:["GENERAL DISAGREEMENT","WRONG CODER","INCORRECT SCORE","INCORRECT EXPORT"],

        sortStatus:"",
        sortStatusesQA:["","NOT REVIEWED","DISPUTED","CODER REVIEWED","MANAGER REVIEWED"],
        statuses:["","NEW","IN PROGRESS", "INCOMPLETE", "QA", "COMPLETE", "DEFICIENT"],
        codeListHeaders:[
            {
            text: 'Status',
            align: 'start',
            sortable: true,
            value: 'status',
            width:'20%'
            },
            { text: 'DOS', value: 'dos',width:'16%' },
            { text: 'FIN', value: 'ext_id',width:'20%' },
            { text: 'Name', value: 'demographics.lastName',width:'22%' },
            {
                text: "Notes  |  View  |  Edit",
                value: "buttons",
                sortable: false,
                align: "center",
                width: "20%"
            },
        ]
      }
    },
    computed: {
        ...mapGetters(["wsUps","listchange","encs","sortStatuses","encPDF","proMode","bigMode","username","userid","userprof"]),
        items () {
            return this.entries.map(entry => {
            const Description = entry.code + " - " + (entry.name.length > this.descriptionLimit
                ? entry.name.slice(0, this.descriptionLimit) + '...'
                : entry.name)

            return Object.assign({}, entry, { Description })
            })
        },
        disableReviewed(){
            //// console.log(this.userprof + " | " + this.selectedLog.status);
            let res = false;
            // if(this.userprof=='coder'){
            //     if(this.selectedLog.status != "NOT REVIEWED"){
            //         res = true;
            //     }
            // }else{
            //     if(this.selectedLog.status == "MANAGER REVIEWED"){
            //         res = true;
            //     }
            // }
            return res;
        },
        displayQADocs(){
            //// console.log(this.userprof + " | " + this.selectedLog.status);
            let res = true;
            if(this.userprof=='coder'){
                if(this.qaFiles.length <= 0){
                    res = false;
                }
            }else{
                
            }
            return res;
        },
        encIdIn(){
          return (this.$route.params && this.$route.params.encid ? this.$route.params.encid : null);
        },
        facility(){
          return (this.$route.params && this.$route.params.facility ? this.$route.params.facility : null);
        },
        client(){
          return (this.$route.params && this.$route.params.client ? this.$route.params.client : null);
        }
    },
    watch:{
      encPDF(docLink){
          if(this.broadcastDocsOpen){
              this.sendMessage("patientDoc", docLink);
          }
      },
      activeDocs:{
          handler: function(docs){
            if(this.broadcastDocsOpen){
                //// console.log("AD CHANGE: " + JSON.stringify(docs));
                this.sendMessage("patientDoc", docs);
            }
          },
          deep:true
      },
      dosProExpand(exp){
          if(exp){
              let dossout = [];
              for(let d=0; d<this.activeEnc.codes.pro.doss.length; d++){
                  dossout.push(d);
              }
              this.prodoss = dossout;
          }else{
              this.prodoss = [];
          }
      },
      dosTechExpand(exp){
          if(exp){
              let dossout = [];
              for(let d=0; d<this.activeEnc.codes.tech.doss.length; d++){
                  dossout.push(d);
              }
              this.techdoss = dossout;
          }else{
              this.techdoss = [];
          }
      },
      dosDxExpand(exp){
          if(exp){
              let dossout = [];
              for(let d=0; d<this.activeEnc.codes.dx.doss.length; d++){
                  dossout.push(d);
              }
              this.dxdoss = dossout;
          }else{
              this.dxdoss = [];
          }
      },
      tableData:{
        handler: function (newData) {
        //   // console.log("CHANGES TO TABLE")
        },
        deep: true,
      },
      codetabtech:{
        handler: function (newData) {
            //// console.log("TECH TAB CHANGE");
            this.forceFormValidate("encform");
        },
        deep: true,
      },
      bigMode(bm){
        this.togglePDF();
        this.toggleBigCode();
      }
    },
    mounted(){
        this.scoreloading = true;
        this.encsloading = true;
        
        

        this.getData(
                "https://gzkoo490fa.execute-api.us-east-1.amazonaws.com/v2/enc/" + this.encIdIn + "/qascoredetail?facility=" + this.facility
            ).then((response) => {
                this.qaScore = response[0];
                this.scoreloading = false;
                this.openRow(response[0],true);
            });
    
        // console.log("VH: " + this.$root.vhNum);
        this.rowHeight = this.$root.vhNum-260;
        this.cardHeight = this.$root.vhNum+102;
        this.svTableCardHeight = this.$root.vhNum-206 + "px";
        this.svTableHeight = this.$root.vhNum-264 + "px";

        // if(this.bigMode){
        //     this.togglePDF();
        //     //this.toggleBigCode();
        // }
       
    },
    methods:{
        changeFont(){
            let pres = document.getElementsByTagName("pre");
            // console.log("FIX PRES " + pres.length);
            for(let p=0; p<pres.length; p++){
                // console.log("FIX PRE");
                pres[p].style.fontFamily = (this.proMode ? 'monospace, monospace' : 'inherit');
            }
        },
        percenter(n,d){
            let out = 0;
            if(d>0){
                out = (n/d)*100;
            }
            return (Math.round(out)+"%");
        },
        // encountersUpdatedInit(){
        //     if(this.origQAEncs){
        //         if(this.userprof == "coder"){
        //             this.qaEncs = this.origQAEncs.filter(enc => enc.status != 'CODER REVIEWED' || enc.status != 'MANAGER REVIEWED');
        //         }else{
        //             this.qaEncs = this.origQAEncs.filter(enc => enc.status != 'MANAGER REVIEWED');
        //         }
        //     }
        // },
        
        markQADis(ctype,btype,dosind,cind,key,subkey){
            //// console.log(ctype + " | " + btype + " | " + dosind + " | " + cind + " | " + key + " | " + subkey);
            let dif = true,
                qaer = this.activeEnc,
                coder = this.encLogDetail;
            
            if(qaer){
                if(subkey && btype){
                    //// console.log("SUBKEY BTYPE");
                    if(qaer.codes[btype] && qaer.codes[btype].doss[dosind] && qaer.codes[btype].doss[dosind][ctype] && qaer.codes[btype].doss[dosind][ctype][cind] && qaer.codes[btype].doss[dosind][ctype][cind][key]){
                        let q,c;
                        if(qaer.codes[btype].doss[dosind][ctype][cind][key][subkey] != null){
                            q = JSON.stringify(qaer.codes[btype].doss[dosind][ctype][cind][key][subkey]);
                            c = JSON.stringify(coder.codes[btype].doss[dosind][ctype][cind][key][subkey]);
                        }else{
                            q = JSON.stringify(qaer.codes[btype].doss[dosind][ctype][cind][key]);
                            c = JSON.stringify(coder.codes[btype].doss[dosind][ctype][cind][key]);
                        }
                        //// console.log (q + " == " + c);
                        if(q == c){
                            dif = false;
                        }
                    }
                }else if(btype){
                    //// console.log("JUST BTYPE");
                    if(qaer.codes[btype] && qaer.codes[btype].doss[dosind] && qaer.codes[btype].doss[dosind][ctype] && qaer.codes[btype].doss[dosind][ctype][cind]){
                        let q = JSON.stringify(qaer.codes[btype].doss[dosind][ctype][cind][key]),
                            c = JSON.stringify(coder.codes[btype].doss[dosind][ctype][cind][key]);
                        //// console.log (q + " == " + c);
                        if(q == c){
                            dif = false;
                        }
                    }
                }else if(dosind >= 0 && subkey){
                    //// console.log("DOSIND SUBKEY");
                    let extrakey = ctype + "s"
                    //// console.log(qaer.codes[ctype].doss[dosind][extrakey][cind]);
                    if(qaer.codes[ctype] && qaer.codes[ctype].doss[dosind] && qaer.codes[ctype].doss[dosind][extrakey] && qaer.codes[ctype].doss[dosind][extrakey][cind] && qaer.codes[ctype].doss[dosind][extrakey][cind][key]){
                        let q,c;
                        if(qaer.codes[ctype].doss[dosind][extrakey][cind][key][subkey]){
                            q = JSON.stringify(qaer.codes[ctype].doss[dosind][extrakey][cind][key][subkey]);
                            c = JSON.stringify(coder.codes[ctype].doss[dosind][extrakey][cind][key][subkey]);
                        }else{
                            q = JSON.stringify(qaer.codes[ctype].doss[dosind][extrakey][cind][key]);
                            c = JSON.stringify(coder.codes[ctype].doss[dosind][extrakey][cind][key]);
                        }
                        //// console.log (q + " == " + c);
                        if(q == c){
                            dif = false;
                        }
                    }
                }else if(dosind!=null && dosind>=0){
                    //// console.log("DOSIND");
                    let extrakey = ctype + "s"
                    if(qaer.codes[ctype] && qaer.codes[ctype].doss[dosind] && qaer.codes[ctype].doss[dosind][extrakey]){
                        let q = JSON.stringify(qaer.codes[ctype].doss[dosind][extrakey][key]),
                            c = JSON.stringify(coder.codes[ctype].doss[dosind][extrakey][key]);
                        //// console.log (q + " == " + c);
                        if(q == c){
                            dif = false;
                        }
                    }
                }else{
                    //// console.log("OTHER");
                    if(qaer.calcs[ctype]){
                        let q = JSON.stringify(qaer.calcs[ctype].results[cind][key]),
                            c = JSON.stringify(coder.calcs[ctype].results[cind][key]);
                        //// console.log (q + " == " + c);
                        if(q == c){
                            dif = false;
                        }
                    }
                }
            }
            //// console.log("DIF: " + dif);
            return (dif ? "border: solid red; " : " ");
        },
        modStringer(mods){
            let out = "";
            for(let m=0; m<mods.length; m++){
                out += mods[m] + (mods.length != m+1 ? ", " : "");
            }
            return out;
        },
        loadFac(){
            // console.log("LOAD FACILITY");
            
            let encid = this.$route.query.encid;
            //let ext_id = this.$route.query.ext_id;
            // console.log(encid);
            // if(encid){
            //     // console.log("LOAD IT UP FROM QUERY")
            //     this.openRow({
            //         encid:encid,
            //         status:null
            //     },true);
            // }
        },
        togglePDF(){
            // // console.log("PDF OPEN: " + this.pdfOpen);
            this.pdfOpen = !this.pdfOpen;
            this.splitView = false;
            // // console.log("OPEN WINDOW? " + this.pdfOpen);
            if(!this.pdfOpen){
                this.broadcastDocs();
            }
        },
        broadcastDocs() {
            // this.createChannel("patientDoc", "PopoutPDFViewer", 800, 600, {
            //     fname: this.encPDF,
            // });
            this.createChannel("patientDoc", "EnahncedPopoutPDFViewer", 800, 600, {
                facility: this.facility,
                client: this.client,
                activeDocs: JSON.stringify(this.activeDocs)
            });
            this.broadcastDocsOpen = true;
        },
        toggleSplitView(){
            // console.log("SPLIT VIEW OPEN: " + this.splitView);
            this.splitView = !this.splitView;
        },
        toggleBigCode(){
            // console.log("BIG CODE VIEW OPEN: " + this.bigCodeView);
            this.bigCodeView = !this.bigCodeView;
        },
        deleteRow(di,ct,type,ind){
            let d = new Date().getTime();
            switch(type){
                case "deficient":
                    if(this.activeEnc.deficients.length == 1){
                        this.activeEnc.deficients[0] = {"deficient_reason":"","provider":"","note":"","user":this.$store.getters.username,"time":d};
                    }else{
                        this.activeEnc.deficients.splice(ind, 1)
                    } 
                    this.defchange++;
                    break;
            }
        },
        addRow(di,ct,type,ind){
            let d = new Date().getTime();
            switch(type){
                case "deficient":
                    this.activeEnc.deficients.splice(ind + 1, 0, {"deficient_reason":"","provider":"","note":"","user":this.$store.getters.username,"time":d});
                    this.defchange++;
                    break;
            }              
        },
        objToValue(val,field){
            if(val[field]){
                return val[field];
            }else{
                return val;
            }
        },
        saveNote(){
            this.saving= true;
            this.newnote.user = this.$store.getters.username;
            this.newnote.time = new Date().getTime();
            
            this.activeEnc.notes = [...this.activeEnc.notes,...[this.newnote]];

            //// console.log("SAVING NOTE: " + JSON.stringify(this.newnote));

            this.postData(
            "https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/encounters/" + this.activeEnc.facility + "/" + this.activeEnc.encid,this.activeEnc
            ).then((response) => {
                //// console.log(response);
                this.saving = false;
                this.newnote = {
                    note_type:"Internal",
                    note:""
                };
            });
        },
        addDef(){
            this.saving= true;
            this.newDef.user = this.$store.getters.username;
            this.newDef.time = new Date().getTime();
            
            this.activeEnc.deficients = [...this.activeEnc.deficients,...[this.newDef]];

            //// console.log("SAVING NOTE: " + JSON.stringify(this.newnote));

            this.postData(
            "https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/encounters/" + this.activeEnc.facility + "/" + this.activeEnc.encid,this.activeEnc
            ).then((response) => {
                //// console.log(response);
                this.saving = false;
                this.newDef = {};
                this.defAdded = true;
            });
        },
        openDispute(row){
            this.disputedialog = true;
        },
        saveQA(row,status){
            this.saving = true;
            let body = {facility: row.facility, userprof: (this.userprof != "coder" ? "manager" : "coder")};
            if(status=="DISPUTED"){
                body.dispute = {};
                body.dispute.user = this.username;
                body.dispute.time = new Date().getTime();
                body.dispute.reason = this.newDis.reason;
                body.dispute.note = this.newDis.note;
            }
            this.postData(
                "https://gzkoo490fa.execute-api.us-east-1.amazonaws.com/v2/enc/" + row.encid + "/updateqastatus/" + status,body
            ).then((response) => {
                // console.log("INP RES: " + response);
                let qaenclen=this.qaEncs.length;
                for(let e=0; e<qaenclen; e++){
                    if(this.qaEncs[e].encid == row.encid){
                        if(status=="DISPUTED"){
                            this.qaEncs[e].dispute = body.dispute;
                            this.qaEncs[e].status = status;
                        }else if(status=="REVIEWED"){
                            this.qaEncs[e].status = body.userprof.toUpperCase() + " " + status;
                        }else{
                            this.qaEncs[e].status = status;
                        }
                        break;
                    }
                }
                this.saving = false;
                if(status=="DISPUTED"){
                    this.disputedialog = false;
                    this.newDis = {};
                };
                this.$store.dispatch("updateUserQAStatuses",{user:this.userid});
                this.closeLogDetail();
            });
        },
        save(status){
            // this.saving= true;
            // if(status != "IN PROGRESS"){
                 
            // }
            // //// console.log(status);
            // this.deficientdialog = false;
            
            // if(status == "QA"){
            //     this.activeEnc.qa_user = this.$store.getters.username;
            //     this.activeEnc.qa_diff = null;
            // }
            // if(this.qaEnc && status == "COMPLETE"){
            //     this.activeQaEnc.status = "COMPLETE";
            //     if(!this.shallowEqual(this.activeQaEnc,this.activeEnc,["discharge_disposition","accident_date"])){
            //         //// console.log("SHALLOW NOT EQUAL");
            //         this.activeEnc.qa_diff = true;
            //     }else if(!this.deepEqual(this.activeQaEnc.codes,this.activeEnc.codes)){
            //         //// console.log("CODE NOT EQUAL");
            //         this.activeEnc.qa_diff = true;
            //     }else if(!this.deepEqual(this.activeQaEnc.calcs,this.activeEnc.calcs)){
            //         //// console.log("CALCS NOT EQUAL");
            //         this.activeEnc.qa_diff = true;
            //     }else if(!this.deepEqual(this.activeQaEnc.cdis,this.activeEnc.cdis)){
            //         //// console.log("CDI NOT EQUAL");
            //         this.activeEnc.qa_diff = true;
            //     }else{
            //         //// console.log("ALL EQUAL");
            //         this.activeEnc.qa_diff = false;    
            //     }
            //     //// console.log("QA DIFF? " + this.activeEnc.qa_diff);

            //     if(this.activeEnc.qa_notes[0] && this.activeEnc.qa_notes[0].note){
            //         if(this.qanotein != this.activeEnc.qa_notes[0].note){
            //             this.activeEnc.qa_notes[0].user = this.$store.getters.username;
            //             this.activeEnc.qa_notes[0].time = new Date().getTime();
            //         }
            //     }else{
            //         this.activeEnc.qa_notes[0].user = this.$store.getters.username;
            //         this.activeEnc.qa_notes[0].time = new Date().getTime();
            //     }
            // }

            // this.activeEnc.status = (status == "QANC" ? "QA" : status);
            
            // //// console.log(JSON.stringify(this.activeEnc));
            // this.postData(
            // "https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/encounters/" + this.activeEnc.facility + "/" + this.activeEnc.encid,this.activeEnc
            // ).then((response) => {
            //     // // console.log("SAVE RES: " + JSON.stringify(response));
            //     if(status != "IN PROGRESS"){
            //         this.activeEnc = {};
            //         this.encLogs=[];
            //         this.qaEnc = false;
            //         this.activeQaEnc = {};
            //         this.$store.dispatch("updateActiveEncStatus","");
            //         //this.$store.dispatch("updateOutgoingEncStatus","");
            //         this.$store.dispatch("updateActiveEncId",null);
            //         this.activeDocs = [{
            //             dockey:"dummy.pdf",
            //             name:"dummy.pdf",
            //             type:"pdf"
            //         }];
            //         this.encLogDetail = {};
            //         history.pushState(null, "", location.href.split("?")[0]);
            //     }
            //     this.saving = false;
            //     this.encValid = false;
            //     this.iniValid = false;
            //     if(this.bigMode){
            //         this.toggleBigCode();
            //     }
            // });
        },
        saveInP(status){
            // this.saving= true;
            // //// console.log(status);
            // this.deficientdialog = false
            // this.activeEnc.status = status;
            // //// console.log(JSON.stringify(this.activeEnc));
            // this.postData(
            //     "https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/encounters/" + this.activeEnc.facility + "/" + this.activeEnc.encid + "/status",
            //     {status:"IN PROGRESS"}
            // ).then((response) => {
            //     // console.log("INP RES: " + response);
            //     this.forceFormValidate("encform");
            //     this.saving = false;
            // });
        },
        openNotesEncList: function(row){
            //// console.log(JSON.stringify(row));
            this.noteListDialog = true;
            this.getData(
                    "https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/encounters/" + this.facility + "/" + row.encid
                ).then((response) => {
                    this.activeEnc = response;
                    
                    if(this.activeEnc.qa_notes && this.activeEnc.qa_notes[0]){
                        this.qanotein = this.activeEnc.qa_notes[0].note;
                    }else{
                        this.activeEnc.qa_notes = [{
                            note:"",
                            user: this.$store.getters.username,
                            time: new Date().getTime()
                        }];
                        this.qanotein = "";
                    }
                    
                    this.$store.dispatch("updateActiveEncId",response.encid);
                    this.notesdialog = true;
                });
        },
        closeNotes(){
            if(this.noteListDialog){
                this.activeEnc = {};
            }
            this.notesdialog=false 
            this.noteListDialog=false
        },
        closeDefs(){
            this.deficientdialog=false 
        },
        closeLogDetail(){
            this.qadialog=false
            this.selectedLog = "";
            this.encLogDetail = {};
        },
        openLastQA(){
            let logs = [...this.encLogs];
            logs.sort((a, b) => b.change_time - a.change_time);
            for(let l=0; l<logs.length; l++){
                if(logs[l].status == "QA"){
                    this.getLogDetail(logs[l].dockey,true);
                    break;
                }
            }
        },
        markQAed(p,e){
            let out = true;
            if(p!=e){
                out = false;
            }
            return out;
        },
        openRow:function(row,readonly){
            if(row.score.sections.tech){
                this.facCTypes.push("TECH");
                if(row.score.sections.tech.doss[0].subsections.em){
                    this.facCodeTypes.push("EM");
                }
                if(row.score.sections.tech.doss[0].subsections.cpt){
                    this.facCodeTypes.push("CPT");
                }
                if(row.score.sections.tech.doss[0].subsections.hcpcs){
                    this.facCodeTypes.push("HCPCS");
                }
            }
            if(row.score.sections.pro){
                this.facCTypes.push("PRO");
                if(row.score.sections.pro.doss[0].subsections.em){
                    this.facCodeTypes.push("EM");
                }
                if(row.score.sections.pro.doss[0].subsections.cpt){
                    this.facCodeTypes.push("CPT");
                }
                if(row.score.sections.pro.doss[0].subsections.hcpcs){
                    this.facCodeTypes.push("HCPCS");
                }
            }
            if(row.score.sections.dx){
                this.facCodeTypes.push("DX");
            }
            if(row.score.sections.ini){
                this.facCTypes.push("TECH");
                this.facCodeTypes.push("INI");
            }

            this.loadingEnc = true;
            this.loadingQAEnc = true;
            
            //this.timeOpened = new Date().getTime();
            //this.readonly = readonly;
            //this.$store.dispatch("updateReadOnlyAE",readonly);
            let status = row.status;
            //this.$store.dispatch("updateActiveEncId",null);
            
            if(this.manualChart){
                // TODO: ADD MANUAL CHART FUNCTIONALITY
            }else{
                //this.openScoreDetail(row.encid,row.facility);
                this.openLog(row);
                this.getData(
                        "https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/encounters/" + row.facility + "/" + row.encid
                    ).then((response) => {
                        
                        this.qadialog = true;
                         
                        //// console.log(response);
                        if(!response.demographics.age && response.demographics.dob){
                            response.demographics.age = this.ageTator(response.demographics.dob);
                        }
                        
                        this.getLogs(response.encid,(status ? status : response.status),(response.qa_user ? true : false));
                        //// console.log(JSON.stringify(this.emToolACEP));
                        this.menu2 = [];
                        this.menu3 = [];

                        this.activeDocs = response.documents;
                        this.getQADocs(response.encid);

                        //history.pushState(null, "", location.href.split("?")[0] + "?encid=" + response.encid);
                        
                        //this.$store.dispatch("updateActiveEncId",response.encid);

                        this.activeEnc = response;
                        
                        this.loadingEnc = false;

                        // if(this.bigMode){
                        //     this.toggleBigCode();
                        // }
                    });
            }
        },
        formatBytes:function(bytes, decimals = 2) {
            if (bytes === 0) return '0 Bytes';

            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

            const i = Math.floor(Math.log(bytes) / Math.log(k));

            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        },
        getQADocs:function(encid){
            this.getData(
                    "https://9ins5mn0lg.execute-api.us-east-1.amazonaws.com/v2/qa_docs/" + encid
                ).then((response) => {
                    // console.log("LOGS: " + response.length);
                    //// console.log(JSON.stringify(response[0]));
                    let filesOut = [];
                    for (let r=0; r<response.length; r++){
                        let d = new Date(response[r].LastModified),
                            filename = response[r].Key.split("/").pop(),
                            filetype = filename.split(".").pop();
                        filesOut.push({
                            filename:filename,
                            sizefix:this.formatBytes(response[r].Size),
                            uploaded:d.toUTCString(),
                            dockey:response[r].Key,
                            filetype:filetype
                        });
                    }
                    this.qaFiles = filesOut;
                });
        },
        openScoreDetail:function(encid,facility){
            this.getData(
                    "https://gzkoo490fa.execute-api.us-east-1.amazonaws.com/v2/enc/"+ encid +"/qascoredetail?facility=" + facility
                ).then((response) => {
                    this.qaScoreDetail = response[0];
                });
        },
        getLogs:function(encid,status,qaed){
            this.getData(
                    "https://8zoc7gp928.execute-api.us-east-1.amazonaws.com/v2/byencounter/" + encid
                ).then((response) => {
                    // console.log("LOGS: " + response.length);
                    //// console.log(JSON.stringify(response[0]));
                    this.encLogs = response;
                    if(!this.readonly && !this.qaEnc && status == "QA"){
                        //this.qaEnc = true;
                        this.openLastQA();
                    }else if(this.readonly && qaed && !this.qaEnc && (status == "COMPLETE" || status == "EXPORT")){
                        //this.qaEnc = true;
                        this.openLastQA();
                    }
                });
        },
        openLog(row){
            this.selectedLog = row;
            this.getLogDetail(row);
        },
        getProviderDetail:function(uuid){
            if(uuid){
                let provDet = this.$store.getters.Providers.find(x => x.uuid == uuid),out="";
                //// console.log(provDet.displayName + " (" + uuid + ")");
                if(provDet && provDet.displayName){
                    out = provDet.displayName + " (" + uuid + ")"
                }else{
                    out = uuid;
                }
                return out;
            }else{
                return "";
            }
        },
        getLogDetail:function(row){
            this.getData(
                    "https://8zoc7gp928.execute-api.us-east-1.amazonaws.com/v2/encdetail/" + row.client + "/" + row.facility + "/" + row.qa_enc_key
                ).then((response) => {
                    this.encLogDetail = response;
                    this.loadingQAEnc = false;
                    this.changeFont();
                });
        },
        
        
        isObject(object) {
            return object != null && typeof object === 'object';
        },
        async postData(url = "", data = {}) {
            const session = await this.$Amplify.Auth.currentSession();
  const iT = session.getIdToken();
  const jwt = iT.getJwtToken();
            // Default options are marked with *
            const response = await fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
                "Content-Type": "application/json",
                "Authorization": jwt
            },
            //redirect: 'follow', // manual, *follow, error
            //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data), // body data type must match "Content-Type" header
            });
            return response.json(); // parses JSON response into native JavaScript objects
        },
        async getData(url = "") {
            const session = await this.$Amplify.Auth.currentSession();
  const iT = session.getIdToken();
  const jwt = iT.getJwtToken();
            // Default options are marked with *
            const response = await fetch(url, {
            method: "GET", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
                "Content-Type": "application/json",
                "Authorization": jwt
            },
            //redirect: 'follow', // manual, *follow, error
            //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            });
            return response.json(); // parses JSON response into native JavaScript objects
        },
        calcAge(){
            //// console.log("CALC AGE");
            this.menudob = false
            if(this.manualChart){
                this.activeEnc.demographics.age = this.ageTator(this.activeEnc.demographics.dob);
            }
        },
        ageTator(dobin){
            //// console.log("DOB IN: " + dobin);
            let out;
            if(dobin && dobin.includes("/")){
                let dobarr = dobin.split("/"),
                    dob = new Date(dobarr[2],dobarr[0],dobarr[1]),
                    diff = Date.now() - dob.getTime(),
                    age = new Date(diff);
                out = Math.abs(age.getUTCFullYear() - 1970);
            }else if(dobin && dobin.includes("-")){
                let dobarr = dobin.split("-"),
                    dob = new Date(dobarr[0],dobarr[1],dobarr[2]),
                    diff = Date.now() - dob.getTime(),
                    age = new Date(diff);
                out = Math.abs(age.getUTCFullYear() - 1970);
            }else{
                out = null;
            }
            return out
        }
    }
  };
</script>

<style>
.v-card {
  display: flex !important;
  flex-direction: column;
}

.v-card__text {
  flex-grow: 1;
  overflow: auto;
}

.demofields{
    border-radius:0;
    font-size: 12px;
    height: 50px;
}

.demofields25{
    border-radius:0;
    font-size: 12px;
    height: 25px;
}

.textareafix textarea{
    line-height: 16px !important; 
    padding: 5px 0px !important;
}

.textareafix2 .v-input__control{
    height:50px !important;
}

.textareafix4 .v-input__control{
    height:100px !important;
}

.error--text{
    font-style: italic !important;
}

.activeLabelOver label:first-of-type{
    transform: translateY(-16px) scale(0.75) !important;
}

.v-expansion-panel-header{
    min-height:32px !important;
}
.v-expansion-panel--active > .v-expansion-panel-header{
    min-height:32px !important;
}
.v-expansion-panel-content__wrap {
    padding: 0 !important;
}

.enctable table {
    table-layout: fixed;
}

.encLogTable{
    border:thin solid rgba(255, 255, 255, 0.12);
}

.encLogTable .v-data-footer{
    height: 50px !important;
}

.encLogTable th + th{
    border-left:thin solid rgba(255, 255, 255, 0.12);
}

.encLogTable td + td{
    border-left:thin solid rgba(255, 255, 255, 0.12);
}

.encLogTableLt{
    border:thin solid rgba(0, 0, 0, 0.12);
}

.encLogTableLt .v-data-footer{
    height: 50px !important;
}

.encLogTableLt th + th{
    border-left:thin solid rgba(0, 0, 0, 0.12);
}

.encLogTableLt td + td{
    border-left:thin solid rgba(0, 0, 0, 0.12);
}
.theme--dark.v-tabs-items{
    background-color: unset;
}
.theme--dark.v-expansion-panels .v-expansion-panel {
    background-color: unset;
}
.theme--dark.v-input--is-disabled{
    color: rgba(255, 255, 255, 0.8) !important;
}

.theme--dark.v-label--is-disabled{
    color:rgba(255, 255, 255, 0.8) !important;
}

.theme--dark.v-input--is-disabled input{
    color: rgba(255, 255, 255, 0.8) !important;
}

.theme--light.v-input--is-disabled{
    color: rgba(0, 0, 0, 0.8) !important;
}

.theme--light.v-label--is-disabled{
    color:rgba(0, 0, 0, 0.8) !important;
    background-color: white !important;
}

.theme--light.v-label--active{
    color:rgba(0, 0, 0, 0.8) !important;
    background-color: white !important;
}

.theme--light.v-input--is-disabled input{
    color: rgba(0, 0, 0, 0.8) !important;
}

tr.v-data-table__selected {
    background: limegreen !important;
  }

.v-data-footer{
    height: 30px !important;
    padding: 0px !important;
    margin: 0px !important;
}
.v-data-footer__select{
    height: 30px !important;
}
.v-card__title{
    padding: 5px !important;
}
.v-dialog{
    min-height: 85% !important;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
</style>